import dayjs from 'dayjs'
import HutritIcon from '../icons/HutritIcon'
import { useNavigate } from 'react-router-dom'
import { PRIVATE_ROUTES, PUBLIC_ROUTES } from '../Routes/routes'
import { useTranslation } from 'react-i18next'

import LinkedinIcon from '../icons/LinkedinIcon'
import useResize from '../hooks/useResize'
import { LINKEDIN_HUTRIT_URL, VIEWPORT_LG } from '../utils/constants'
import { openNewTab } from '../utils'
import { CALENDLY_API_URL } from '../services/constants'
// import { listOfPublicVacancies } from '../services/OfferManagement'
// import { useQuery } from '@tanstack/react-query'
import { useLandingStore } from '../store'

const Footer = () => {
  const { t } = useTranslation()
  const today = dayjs().year()
  const navigate = useNavigate()
  const viewportSize = useResize()
  const { setTypeOfLanding } = useLandingStore()
  const isMobile = viewportSize[0] <= VIEWPORT_LG

  // const {
  //   data: listOfPublicVacanciesData = {},
  //   isLoading: isInitialLoadingListOfPublicVacancies,
  // } = useQuery(['list-of-public-vacancies'], listOfPublicVacancies)

  // const { offers: vacancies } = listOfPublicVacanciesData ?? {}

  // const firstVacancieId = vacancies?.[0]?.id ?? 0
  // const defaultTmLink = 'IzYxMi1S'

  const handleGoToTermsAndConditions = () => {
    navigate(PUBLIC_ROUTES.terms_and_conditions)
  }

  return (
    <footer
      className={`${
        window.location.pathname === PRIVATE_ROUTES.talents ? 'd-none' : ''
      } footer z-index-footer text-white`}
      style={{
        background: '#001F1F',
        fontSize: isMobile ? '12px' : '16px',
      }}
    >
      <div
        className="d-flex align-items-start justify-content-around"
        style={{
          paddingTop: isMobile ? '24px' : '48px',
          paddingLeft: isMobile ? '32px' : '64px',
          paddingRight: isMobile ? '32px' : '64px',
        }}
      >
        <div className="d-lg-flex d-none">
          <HutritIcon />
        </div>
        <div
          className="d-flex flex-column d-none"
          style={{
            gap: '16px',
          }}
        >
          <span
            className="cursor-pointer"
            onClick={() => {
              navigate(PUBLIC_ROUTES.home)
              setTypeOfLanding('company')
            }}
          >
            {t('companies')}
          </span>
        </div>
        <div
          className="d-flex flex-column"
          style={{
            gap: '16px',
          }}
        >
          <span
            className="cursor-pointer"
            onClick={() => openNewTab({ url: CALENDLY_API_URL })}
          >
            {t('schedule_demo')}
          </span>
        </div>
        <div
          className="d-flex flex-column"
          style={{
            gap: '16px',
          }}
        >
          <span
            className="cursor-pointer"
            onClick={() => {
              navigate(PUBLIC_ROUTES.login)
            }}
          >
            {t('log_in')}
          </span>
          <span
            className="cursor-pointer"
            onClick={() => {
              navigate('/register-company')
            }}
          >
            {t('sign_up')}
          </span>
          <span
            className="cursor-pointer"
            onClick={() => {
              navigate(PUBLIC_ROUTES.contact_us)
            }}
          >
            {t('contact_us')}
          </span>
        </div>
        <div
          className="d-flex flex-column cursor-pointer"
          style={{
            gap: '16px',
          }}
          onClick={() => {
            openNewTab({ url: LINKEDIN_HUTRIT_URL })
          }}
        >
          <span>Síguenos en</span>
          <LinkedinIcon />
        </div>
      </div>
      <div
        className="w-100"
        style={{
          height: '1px',
          background: '#FFF˝',
          paddingTop: '40px',
          paddingBottom: '40px',
        }}
      />

      <div className="mb-4 mt-4 d-flex justify-content-center align-items-center gap-3 gap-lg-2 text-white w-100">
        <p className="font-extra-small">
          &copy;Copyright <span id="copyright"> {today.toString()}</span> Hutrit
        </p>

        <p className="font-extra-small">{t('privacy')}</p>
        <p
          className="font-extra-small text-decoration-underline cursor-pointer"
          onClick={handleGoToTermsAndConditions}
        >
          {t('terms_and_conditions')}
        </p>
      </div>
    </footer>
  )
}

export default Footer
